<template>
  <div class="role box">
    <div class="left-box">
      <div class="head-box">
        <h4>角色管理</h4>
        <div>
          <i class="el-icon-circle-plus-outline c-pointer h-primary" @click="addRole()"></i>
          <i class="el-icon-edit c-pointer c-m-l-15 h-primary" @click="editRole()"></i>
          <i class="el-icon-delete c-pointer c-m-l-15 h-danger" @click="removeRole()"></i>
        </div>
      </div>
      <div class="left-content row">
        <div class="content-group">
          <div
            v-for="(item, i) in roles"
            :key="i"
            class="content-item"
            :class="activeRole._id == item._id ? 'is-selected' : ''"
            @click="roleClick(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="right-box func-tree c-p-10">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="数据权限" name="dataAuth">
          <div>
            <div class="f-s-14 m-10">
              请设置该角色的数据权限（包括：读取、修改、删除)
            </div>
            <el-radio-group v-model="activeRole.dataAuth">
              <el-radio :label="1" border>本人</el-radio>
              <el-radio :label="2" border>本部门</el-radio>
              <el-radio :label="3" border>本部门及下级部门</el-radio>
              <el-radio :label="4" border>全部</el-radio>
            </el-radio-group>
            <el-button
              type="success"
              class="m-10 m-t-20 w-200"
              @click="saveRole('setDataAuth', true)"
            >
              保存
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="功能权限" name="funcAuth">
          <el-tree
            :data="treeData"
            show-checkbox
            default-expand-all
            :expand-on-click-node="false"
            :indent="50"
            node-key="_id"
            ref="tree"
            :props="defaultProps"
            style="height: auto;"
          >
            <span
              :class="data.type == 'button' ? 'buttons' : ''"
              class="custom-tree-node c-w-1"
              style="overflow: auto;"
              slot-scope="{ node, data }"
            >
              <div>
                <i :class="data.icon ? 'm-r-5 ' + data.icon : ''"></i>
                <span
                  :class="data.icon ? 'f-w-500' : ''"
                  style="display: flex;flex-wrap: wrap;width: 100%;"
                >
                  <span class="m-r-20" style="margin-top: 2px;margin-bottom: 2px;">
                    <span v-if="!data.color">{{ data.name }}</span>
                    <el-tag
                      v-else
                      effect="dark"
                      :color="data.color"
                      style="border:none;margin-top: 2px;margin-bottom: 2px;"
                    >
                      {{ data.name }}
                    </el-tag>
                  </span>
                  <el-checkbox
                    class="m-r-20"
                    style="margin-top: 2px;margin-bottom: 2px;"
                    v-for="(item, i) in data.buttonList"
                    :key="i"
                    v-model="buttonIds"
                    :label="item._id"
                    border
                    size="mini"
                  >
                    {{ item.label }}
                  </el-checkbox>
                </span>
              </div>
            </span>
          </el-tree>
        </el-tab-pane>
      </el-tabs>
      <el-button
        v-if="activeTab == 'funcAuth' && treeData.length > 0"
        type="success"
        class="m-10 w-200"
        @click="saveFunAuth()"
      >
        保存设置
      </el-button>
    </div>
    <el-dialog title="角色信息" :visible.sync="roleDialog" width="500px">
      <el-form :model="activeRole" ref="formData" :rules="rules">
        <el-form-item label="编号" label-width="60px" prop="code">
          <el-input v-model="activeRole.code"></el-input>
        </el-form-item>
        <el-form-item label="名称" label-width="60px" prop="name">
          <el-input v-model="activeRole.name"></el-input>
        </el-form-item>
        <el-form-item label="描述" label-width="60px">
          <el-input v-model="activeRole.memo"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="saveRole()">确 定</el-button>
        <el-button @click="roleDialog = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'role',
  data() {
    return {
      type: '', //平台type=a,租户type=c
      roles: [], //左侧所有角色
      //右侧激活tab页
      activeTab: 'dataAuth',
      //角色对话框
      roleDialog: false,
      activeRole: {}, //当前选择角色
      //菜单树
      treeData: [],
      buttonIds: [],
      defaultProps: {
        children: 'functionList',
        label: 'name'
      },
      roleRules: {
        name: [{ required: true, trigger: 'blur', message: '名称不能为空' }]
      },
      rules: this.$util.rules,
      currentRole: {}
    };
  },
  mounted() {
    this.doInit();
    this.currentRole = JSON.parse(sessionStorage.getItem('currentRole'));
  },
  methods: {
    doInit() {
      window.$this = this;
      this.type = this.osg.param('type');
      this.getRoles();
    },
    //标签页切换
    handleClick(tab, event) {},
    //获取所有角色
    getRoles() {
      this.osg.ajax(
        'role/query.do',
        { _all: '1', 'is:state|integer#and': 1, 'in:type|array#and': this.type },
        res => {
          this.roles = res.data;
        }
      );
    },
    //选择角色
    roleClick(item) {
      this.activeRole = this.$util.deepCopy(item);
      this.buttonIds = this.activeRole.buttonIds; //按钮
      this.roleId = this.activeRole._id;
      if (this.activeRole.type == 'cc') {
        // 平台管理员展示全部菜单
        this.getTree(item.type);
      } else {
        // 非平台管理员展示当前登录人拥有的菜单
        this.getTreeByRole(this.currentRole._id);
      }
    },
    //新增角色
    addRole() {
      this.activeRole = {};
      this.roleDialog = true;
    },
    //保存角色
    saveRole(setDataAuth, isValidate) {
      if (setDataAuth == 'setDataAuth' && !this.activeRole._id) {
        this.osg.toast('请先选择要设置的角色！', 'warning');
        return;
      }
      if (!isValidate) {
        if (!this.osg.validate()) {
          return;
        }
      }
      this.activeRole.type = this.activeRole.type || this.type; //类型a:平台 b:租户
      this.activeRole.order = this.activeRole.order || this.roles.length + 1; //排序
      this.activeRole.dataAuth = this.activeRole.dataAuth || 1; //自身数据权限 || 默认数据权限
      // 下面代码放开会有问题，如果未打开功能权限页签只是保存数据权限，会覆盖选中菜单为空数组导致菜单丢失。
      // activeRole.checkedFunctionIds = JSON.stringify(this.checkedFunctionIds || []); //全选中的菜单id数组字符串
      this.activeRole.buttonIds = this.buttonIds.join(); //按钮id数组
      this.osg.ajax('role/upsert.do', this.activeRole, () => {
        this.osg.toast('保存成功！');
        this.roleDialog = false;
        this.getRoles();
      });
    },
    //新增/编辑角色
    editRole() {
      if (!this.activeRole) {
        this.osg.toast('请选择要编辑的角色！', 'warning');
      } else {
        this.roleDialog = true;
      }
    },
    //删除角色
    removeRole() {
      if (!this.activeRole) {
        this.osg.toast('请选择要删除的角色！', 'warning');
      } else {
        this.osg.confirm(`是否确认删除角色"${this.activeRole.name}"`, () => {
          this.osg.ajax(`role/remove/${this.activeRole._id}.do`, {}, res => {
            this.osg.toast('删除成功！');
            this.getRoles();
          });
        });
      }
    },
    //获取菜单和按钮
    getTree(type) {
      this.osg.ajax('function/queryTree.do', { type }, res => {
        this.treeData = res.data.functionList;
        //勾选树组件
        this.$refs.tree.setCheckedKeys(JSON.parse(this.activeRole.checkedFunctionIds || '[]'));
      });
    },
    // 获取角色菜单和按钮
    getTreeByRole(roleId) {
      this.osg.ajax('function/queryTreeByRoleId.do', { roleId }, res => {
        this.treeData = res.data.functionList;
        //勾选树组件
        this.$refs.tree.setCheckedKeys(JSON.parse(this.activeRole.checkedFunctionIds || '[]'));
      });
    },
    //保存功能权限
    saveFunAuth() {
      if (!this.activeRole) {
        this.osg.toast('请先选择要设置的角色！', 'warning');
        return;
      }
      // 保存全选中的叶子节点菜单 用作树组件返显
      this.activeRole.checkedFunctionIds = JSON.stringify(this.$refs.tree.getCheckedKeys(true));
      // 保存全选中的所有节点菜单 和半选中的菜单 用作后台返回可见菜单
      this.activeRole.functionIds = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      this.saveRole(true, true);
    }
  }
  // watch: {
  //   $route() {
  //     this.doInit();
  //   }
  // }
};
</script>
<style scoped>
/* 数据权限选择按钮 */
.func-tree .el-radio-group {
  display: flex;
  flex-direction: column;
}
.func-tree .el-radio-group > label {
  width: 200px;
  margin: 10px;
}
.row .content-item {
  font-size: initial !important;
}
.el-tabs__content {
  overflow-y: auto;
}
</style>
<style>
/*菜单权限树*/
.func-tree .el-form-item__label {
  text-align: center !important;
}
.func-tree .el-tree-node__content {
  padding: 0px 10px 0px 0;
  margin: 2px 0px;
  height: auto;
}
.func-tree
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__children
  > .is-expanded {
  display: inline-block;
}
.func-tree
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__children {
  padding-left: 100px;
}
.func-tree
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__content {
  padding-left: 0 !important;
  height: auto;
}
.role .right-box > .el-tabs {
  height: 100%;
  overflow: hidden;
}
.role .right-box > .el-tabs .el-tabs__content {
  height: 100%;
}
.role .right-box > .el-tabs .el-tabs__content #pane-funcAuth {
  height: calc(100% - 55px);
  overflow: auto;
}
</style>
